import { graphql } from '../../../../gql';

export const GET_USER_FEED = graphql(`
  query getUserFeed(
    $userId: String!
    $feedType: String
    $feedTypes: [FeedEntryType!]
    $cursor: String
    $limit: Int
    $minRelevanceScore: Float
    $excludeAuthors: [String!]
    $topic: String
  ) {
    getUserFeed(
      userId: $userId
      feedType: $feedType
      feedTypes: $feedTypes
      cursor: $cursor
      limit: $limit
      minRelevanceScore: $minRelevanceScore
      excludeAuthors: $excludeAuthors
      topic: $topic
    ) {
      posts {
        id
        userId
        username
        author {
          authorId
          username
          avatarUrl
        }
        textBlocks {
          ...TextBlockFields
        }
        postAnalytics {
          ...PostAnalyticsCardFields
        }
        article
        createdAt
        updatedAt
        viewerInteractions {
          ...ViewerInteractionFields
          likeCount
          bookmarkCount
        }
        isFollowingAuthor
        replyTo {
          id
          author {
            username
          }
        }
        feedMetadata {
          ...FeedMetadataFields
        }
        parentPostId
        rootPostId
        depth
        replyCount
        score
        lastRepliedAt
        storyAnalysis {
          ...FeedStoryAnalysisFields
        }
        hasStoryAnalysis
        storyAnalysisLocation
        moderationStatus
        moderation {
          ...PostModerationMetaFields
        }
        communityReports {
          ...CommunityReportFields
        }
      }
      pageInfo {
        hasNextPage
        endCursor
        totalCount
      }
      feedStats {
        feedTypeDistribution {
          type
          count
        }
        totalRelevanceScore
      }
    }
  }
`);
